var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefits-menu"},[_c('div',{staticClass:"content mb-8"},[(
        (_vm.benefits && _vm.benefits.length > 0) ||
          (_vm.giftCertificatesReceived && _vm.giftCertificatesReceived.length > 0)
      )?_vm._l((_vm.benefits),function(benefit,index){return _c('GiftMenuCard',{key:index,attrs:{"benefit":benefit,"index":index}})}):_c('p',{staticClass:"no-treshold"},[_vm._v(" "+_vm._s(_vm.$t("benefits.noBenefits"))+" ")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }